<template>
	<article 
		:id="id" 
		:class="[labelClass, 
			'dc-post-grid-card default-card post-summary default'
		]"
		v-on:click.stop.prevent="goToPost()">
		<div class="dc-post-grid-card-inner post-summary-inner">
			<div :class="['image-wrapper', {
				'no-image': !image
			}]">
				<img v-if="image" :src="image.src" :srcset="image.srcset" :alt="image.alt" />
			</div>
			<div ref="cardContentWrapper" class="content-wrapper">
				<div ref="cardContentHoverOverlay" class="content-hover-overlay"></div>
                <span class="post-date" v-if="date">{{ date }}</span>
				<a v-if="label && typeof label.url !== 'undefined'" :href="label.url" class="post-summary-category">{{ label.title }}</a>
				<span v-if="label && typeof label.url === 'undefined'" class="post-summary-category">{{ label.title }}</span>
				<h1 v-if="title" class="card-title">{{ title }}</h1>
				<div v-if="excerpt" class="card-excerpt" v-html="excerpt"></div>
				<a ref="postLink" v-if="url" :href="url" class="link read-more-link">
					<span class="screen-reader-text">Read more</span>
				</a>
			</div>
		</div>
	</article>
</template>

<script>
export default {
	props: {
	    id: {
	      type: String|Number,
	      required: true
	    },
		title: {
	      type: String,
	      required: true
	    },
		url: {
	      type: String,
	      required: true
	    },
		excerpt: {
	      type: String,
	      required: false
	    },
		label: {
	      type: Object,
	      required: false
	    },
		image: {
	      type: Object,
	      required: false
	    },
        date: {
            type: String,
            required: false,
        },
	},
	computed: {
		labelClass() {
			if (typeof this.label === 'undefined' || typeof this.label.class === 'undefined') return '';
			return this.label.class;
		}
	},
	methods: {
		goToPost() {
			window.location.href = this.url
		}
	}
}
</script>
